import { render, staticRenderFns } from "./MessagesController.vue?vue&type=template&id=18e22a6a"
import script from "./MessagesController.vue?vue&type=script&lang=js"
export * from "./MessagesController.vue?vue&type=script&lang=js"
import style0 from "./MessagesController.vue?vue&type=style&index=0&id=18e22a6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_@vue+compiler-sfc@3.5.17_b_3cd151110130808e214f6f819bd7543a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports